import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/$/, '');

function rgb(hex) {
  const c = (hex||'#6366f1').replace('#','');
  const f = c.length===3?c.split('').map(x=>x+x).join(''):c;
  const n = parseInt(f,16);
  return `${(n>>16)&255},${(n>>8)&255},${n&255}`;
}
function star(rating) {
  return '★'.repeat(Math.round(rating||0)) + '☆'.repeat(5-Math.round(rating||0));
}
function fmtPrice(p, currency='NPR') {
  if (!p && p !== 0) return '';
  return `${currency} ${(p/100).toFixed(2)}`;
}

const CAT_ICONS = { cafe:'☕',restaurant:'🍽️',retail:'🛍️',gym:'💪',salon:'✂️',clinic:'🏥',hotel:'🏨',education:'🎓',event:'🎪',other:'🏢' };

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=Syne:wght@700;800&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
.bi-root{min-height:100vh;background:#080b14;color:#e2e8f0;font-family:'DM Sans',sans-serif;}
@keyframes fadeUp{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
@keyframes spin{to{transform:rotate(360deg)}}
.fade-in{animation:fadeUp .35s both;}
.fade-d1{animation-delay:.07s} .fade-d2{animation-delay:.14s} .fade-d3{animation-delay:.21s}
/* Hero */
.bi-hero{position:relative;height:260px;overflow:hidden;}
.bi-hero-img{width:100%;height:100%;object-fit:cover;opacity:.55;}
.bi-hero-bg{width:100%;height:100%;background:linear-gradient(135deg,#0d1f3c,#1a3a5c);}
.bi-hero::after{content:'';position:absolute;inset:0;background:linear-gradient(to bottom,transparent 30%,#080b14 100%);}
.bi-logo-wrap{position:absolute;bottom:-44px;left:50%;transform:translateX(-50%);z-index:2;
  width:90px;height:90px;border-radius:18px;overflow:hidden;border:3px solid #080b14;
  background:#1a2540;display:flex;align-items:center;justify-content:center;font-size:36px;}
.bi-logo-wrap img{width:100%;height:100%;object-fit:cover;}
/* Content */
.bi-body{max-width:680px;margin:0 auto;padding:60px 16px 40px;}
/* Name block */
.bi-name{font-family:'Syne',sans-serif;font-size:clamp(22px,6vw,30px);font-weight:800;text-align:center;margin-bottom:6px;}
.bi-cat{text-align:center;font-size:13px;color:#64748b;margin-bottom:10px;display:flex;align-items:center;justify-content:center;gap:6px;}
.bi-desc{font-size:14px;color:#94a3b8;line-height:1.75;text-align:center;margin-bottom:20px;padding:0 4px;}
/* Quick info pills */
.bi-info-row{display:flex;flex-wrap:wrap;gap:8px;justify-content:center;margin-bottom:20px;}
.bi-pill{display:inline-flex;align-items:center;gap:5px;padding:6px 12px;border-radius:99px;
  background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.08);font-size:12px;color:#94a3b8;text-decoration:none;}
.bi-pill:hover{background:rgba(255,255,255,.1);color:#e2e8f0;}
/* Tabs */
.bi-tabs{display:flex;gap:2px;border-bottom:1px solid rgba(255,255,255,.07);margin-bottom:20px;overflow-x:auto;}
.bi-tab{padding:10px 16px;border:none;background:transparent;color:#64748b;font-family:'DM Sans',sans-serif;
  font-size:13px;font-weight:600;cursor:pointer;border-bottom:2px solid transparent;white-space:nowrap;transition:all .18s;}
.bi-tab.active{color:var(--acc);border-bottom-color:var(--acc);}
.bi-tab:hover{color:#e2e8f0;}
/* Products */
.bi-prod-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(160px,1fr));gap:12px;}
.bi-prod-card{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.07);border-radius:14px;overflow:hidden;cursor:pointer;transition:all .18s;}
.bi-prod-card:hover{border-color:rgba(var(--rgb),.35);transform:translateY(-2px);}
.bi-prod-img{width:100%;height:130px;object-fit:cover;background:#1a2540;display:flex;align-items:center;justify-content:center;font-size:36px;}
.bi-prod-img img{width:100%;height:100%;object-fit:cover;}
.bi-prod-body{padding:10px 12px;}
.bi-prod-name{font-size:13px;font-weight:600;color:#e2e8f0;margin-bottom:3px;}
.bi-prod-price{font-size:12px;color:var(--acc);font-weight:700;}
.bi-prod-stock{font-size:10px;color:#64748b;margin-top:2px;}
/* Reviews */
.bi-review-card{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.07);border-radius:12px;padding:14px;margin-bottom:10px;}
.bi-review-head{display:flex;align-items:center;gap:10px;margin-bottom:6px;}
.bi-review-avatar{width:34px;height:34px;border-radius:50%;background:rgba(var(--rgb),.2);display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;color:var(--acc);flex-shrink:0;}
.bi-review-avatar img{width:100%;height:100%;object-fit:cover;border-radius:50%;}
.bi-review-name{font-size:13px;font-weight:600;color:#e2e8f0;}
.bi-review-stars{font-size:11px;color:#fbbf24;letter-spacing:1px;}
.bi-review-badge{font-size:9px;padding:2px 8px;border-radius:99px;background:rgba(52,211,153,.1);color:#34d399;border:1px solid rgba(52,211,153,.2);}
.bi-review-text{font-size:13px;color:#94a3b8;line-height:1.6;}
/* Map */
.bi-map-wrap{border-radius:14px;overflow:hidden;height:240px;border:1px solid rgba(255,255,255,.07);}
.bi-map-wrap iframe{width:100%;height:100%;border:none;}
/* Action bar */
.bi-bar{position:fixed;bottom:0;left:0;right:0;background:rgba(8,11,20,.97);border-top:1px solid rgba(255,255,255,.07);
  padding:12px 16px;padding-bottom:max(12px,env(safe-area-inset-bottom));
  display:flex;gap:8px;justify-content:center;z-index:100;}
.bi-bar-btn{flex:1;max-width:180px;padding:12px;border-radius:12px;border:none;font-family:'DM Sans',sans-serif;
  font-size:13px;font-weight:700;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:6px;transition:all .18s;}
.bi-bar-primary{color:#fff;}
.bi-bar-ghost{color:var(--acc);border:1.5px solid rgba(var(--rgb),.35);background:rgba(var(--rgb),.08);}
/* Section */
.bi-sec{margin-bottom:20px;}
.bi-sec-title{font-size:10px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:var(--acc);
  margin-bottom:14px;display:flex;align-items:center;gap:8px;}
.bi-sec-title::after{content:'';flex:1;height:1px;background:linear-gradient(to right,rgba(var(--rgb),.3),transparent);}
/* Rating summary */
.bi-rating-big{display:flex;align-items:center;gap:16px;padding:16px;background:rgba(255,255,255,.04);border-radius:14px;margin-bottom:14px;}
.bi-rating-num{font-family:'Syne',sans-serif;font-size:40px;font-weight:800;color:var(--acc);line-height:1;}
.bi-rating-stars{font-size:18px;color:#fbbf24;letter-spacing:2px;}
.bi-rating-count{font-size:12px;color:#64748b;}
/* Empty */
.bi-empty{text-align:center;padding:40px 20px;color:#334155;}
.bi-empty-ico{font-size:40px;margin-bottom:10px;}
/* Section card */
.bi-card{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.07);border-radius:14px;padding:16px;margin-bottom:10px;}
.bi-spinner{width:32px;height:32px;border:3px solid rgba(99,102,241,.15);border-top-color:#6366f1;border-radius:50%;animation:spin .7s linear infinite;}
/* Modal */
.bi-modal-bg{position:fixed;inset:0;background:rgba(0,0,0,.8);z-index:200;display:flex;align-items:flex-end;justify-content:center;}
@media(min-width:500px){.bi-modal-bg{align-items:center;padding:20px;}}
.bi-modal{background:#0d1a2e;border:1px solid rgba(255,255,255,.1);border-radius:20px 20px 0 0;width:100%;max-width:460px;padding:24px 18px;padding-bottom:max(24px,env(safe-area-inset-bottom));}
@media(min-width:500px){.bi-modal{border-radius:20px;}}
.bi-modal-title{font-family:'Syne',sans-serif;font-size:18px;font-weight:800;color:#e2e8f0;margin-bottom:4px;}
.bi-qty-row{display:flex;align-items:center;gap:12px;margin:16px 0;}
.bi-qty-btn{width:34px;height:34px;border-radius:10px;border:1px solid rgba(255,255,255,.1);background:rgba(255,255,255,.06);color:#e2e8f0;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;}
.bi-variant-grid{display:flex;flex-wrap:wrap;gap:7px;margin:10px 0 16px;}
.bi-variant-btn{padding:7px 13px;border-radius:8px;border:1px solid rgba(255,255,255,.1);background:rgba(255,255,255,.04);color:#94a3b8;font-size:12px;cursor:pointer;transition:all .15s;}
.bi-variant-btn.active{border-color:var(--acc);background:rgba(var(--rgb),.12);color:var(--acc);}
`;

export default function BusinessInfo() {
  const { slug }  = useParams();
  const navigate  = useNavigate();
  const [biz,     setBiz]     = useState(null);
  const [products,setProducts]= useState([]);
  const [tab,     setTab]     = useState('overview');
  const [loading, setLoading] = useState(true);
  const [modal,   setModal]   = useState(null); // selected product
  const [qty,     setQty]     = useState(1);
  const [variant, setVariant] = useState(null);
  const [cartLoading, setCartLoading] = useState(false);
  const [cartMsg, setCartMsg] = useState('');

  const colour = biz?.accentColor || '#6366f1';
  const r      = rgb(colour);

  useEffect(() => {
    if (!slug) return;
    // Fetch business by slug via userinfo-style endpoint
    axios.get(`${API_BASE}/business/public/${encodeURIComponent(slug)}`)
      .then(({ data }) => setBiz(data))
      .catch(() => setLoading(false))
      .finally(() => setLoading(false));
  }, [slug]);

  useEffect(() => {
    if (!biz?._id) return;
    axios.get(`${API_BASE}/business/${biz._id}/products`)
      .then(({ data }) => setProducts(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, [biz]);

  const addToCart = async () => {
    if (!modal) return;
    setCartLoading(true);
    try {
      const token = localStorage.getItem('token');
      if (!token) { navigate('/login'); return; }
      await axios.post(`${API_BASE}/storefront/cart/${biz._id}`,
        { productId: modal._id, variantId: variant?._id||null, qty },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCartMsg('Added to cart! ✅');
      setTimeout(() => { setCartMsg(''); setModal(null); }, 1500);
    } catch (e) { setCartMsg(e.response?.data?.error || 'Error'); }
    setCartLoading(false);
  };

  if (loading) return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#080b14'}}>
      <div className="bi-spinner"/>
      <style>{CSS}</style>
    </div>
  );

  if (!biz) return (
    <div style={{minHeight:'100vh',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',background:'#080b14',color:'#64748b',gap:12}}>
      <style>{CSS}</style>
      <div style={{fontSize:48}}>🏢</div>
      <div style={{fontSize:18,color:'#e2e8f0',fontWeight:700}}>Business not found</div>
      <Link to="/" style={{color:'#6366f1',fontSize:13}}>← Go home</Link>
    </div>
  );

  const catIcon = CAT_ICONS[biz.category] || '🏢';
  const reviews = (products||[]).flatMap(p => (p.reviews||[])).slice(0,10);
  const avgRating = reviews.length ? (reviews.reduce((s,r)=>s+r.rating,0)/reviews.length).toFixed(1) : null;
  const lat = biz.location?.coordinates?.[1];
  const lng = biz.location?.coordinates?.[0];

  return (
    <div className="bi-root" style={{'--acc':colour,'--rgb':r}}>
      <style>{CSS}</style>

      {/* Hero */}
      <div className="bi-hero">
        {biz.coverPhoto ? <img src={biz.coverPhoto} alt="cover" className="bi-hero-img"/> : <div className="bi-hero-bg"/>}
        <div className="bi-logo-wrap">
          {biz.logo ? <img src={biz.logo} alt={biz.name}/> : <span>{catIcon}</span>}
        </div>
      </div>

      {/* Body */}
      <div className="bi-body">
        <div className="fade-in">
          <h1 className="bi-name">{biz.name}</h1>
          <div className="bi-cat"><span>{catIcon}</span><span>{biz.category}</span>{avgRating&&<><span>·</span><span style={{color:'#fbbf24'}}>★ {avgRating}</span></>}</div>
          {biz.description && <p className="bi-desc">{biz.description}</p>}

          <div className="bi-info-row">
            {biz.address && <span className="bi-pill">📍 {biz.address}</span>}
            {biz.phone   && <a href={`tel:${biz.phone}`} className="bi-pill">📞 {biz.phone}</a>}
            {biz.email   && <a href={`mailto:${biz.email}`} className="bi-pill">✉️ {biz.email}</a>}
            {biz.website && <a href={biz.website} target="_blank" rel="noreferrer" className="bi-pill">🌐 Website</a>}
          </div>
        </div>

        {/* Tabs */}
        <div className="bi-tabs fade-in fade-d1">
          {[['overview','📋 Overview'],['products','🛍️ Products'],['reviews','⭐ Reviews'],['location','📍 Location']].map(([id,label])=>(
            <button key={id} className={`bi-tab${tab===id?' active':''}`} onClick={()=>setTab(id)}>{label}</button>
          ))}
        </div>

        {/* OVERVIEW */}
        {tab==='overview' && (
          <div className="fade-in fade-d2">
            {products.filter(p=>p.isFeatured).length > 0 && (
              <div className="bi-sec">
                <div className="bi-sec-title">Featured Products</div>
                <div className="bi-prod-grid">
                  {products.filter(p=>p.isFeatured).slice(0,4).map(p=>(
                    <div key={p._id} className="bi-prod-card" onClick={()=>{setModal(p);setQty(1);setVariant(null);}}>
                      <div className="bi-prod-img">{p.images?.[0]?<img src={p.images[0]} alt={p.name}/>:<span>🛍️</span>}</div>
                      <div className="bi-prod-body">
                        <div className="bi-prod-name">{p.name}</div>
                        <div className="bi-prod-price">{fmtPrice(p.price, p.currency)}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {biz.modules?.loyalty && (
              <div className="bi-sec">
                <div className="bi-sec-title">Loyalty Program</div>
                <div className="bi-card" style={{display:'flex',alignItems:'center',gap:14}}>
                  <div style={{fontSize:36}}>⭐</div>
                  <div>
                    <div style={{fontSize:14,fontWeight:700,color:'#e2e8f0',marginBottom:3}}>Earn points with every visit</div>
                    <div style={{fontSize:12,color:'#64748b'}}>Tap your Flap card when you visit to collect loyalty points</div>
                  </div>
                </div>
              </div>
            )}
            {biz.modules?.membership && (
              <div className="bi-sec">
                <div className="bi-sec-title">Membership</div>
                <div className="bi-card" style={{display:'flex',alignItems:'center',gap:14}}>
                  <div style={{fontSize:36}}>💳</div>
                  <div>
                    <div style={{fontSize:14,fontWeight:700,color:'#e2e8f0',marginBottom:3}}>Members get exclusive benefits</div>
                    <div style={{fontSize:12,color:'#64748b'}}>Join as a member for special discounts and priority access</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* PRODUCTS */}
        {tab==='products' && (
          <div className="fade-in fade-d2">
            {products.length === 0 ? (
              <div className="bi-empty"><div className="bi-empty-ico">🛍️</div><div>No products listed yet</div></div>
            ) : (
              <div className="bi-prod-grid">
                {products.map(p => (
                  <div key={p._id} className="bi-prod-card" onClick={()=>{setModal(p);setQty(1);setVariant(null);}}>
                    <div className="bi-prod-img">{p.images?.[0]?<img src={p.images[0]} alt={p.name}/>:<span>📦</span>}</div>
                    <div className="bi-prod-body">
                      <div className="bi-prod-name">{p.name}</div>
                      <div className="bi-prod-price">{fmtPrice(p.price, p.currency)}</div>
                      {p.stock !== null && <div className="bi-prod-stock">{p.stock > 0 ? `${p.stock} in stock` : 'Out of stock'}</div>}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* REVIEWS */}
        {tab==='reviews' && (
          <div className="fade-in fade-d2">
            {avgRating && (
              <div className="bi-rating-big">
                <div className="bi-rating-num">{avgRating}</div>
                <div>
                  <div className="bi-rating-stars">{star(parseFloat(avgRating))}</div>
                  <div className="bi-rating-count">{reviews.length} review{reviews.length!==1?'s':''}</div>
                </div>
              </div>
            )}
            {reviews.length === 0 ? (
              <div className="bi-empty"><div className="bi-empty-ico">⭐</div><div>No reviews yet — be the first!</div></div>
            ) : reviews.map((rv,i) => (
              <div key={i} className="bi-review-card">
                <div className="bi-review-head">
                  <div className="bi-review-avatar">{rv.userPhoto?<img src={rv.userPhoto} alt=""/>:(rv.userName||'?')[0].toUpperCase()}</div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{display:'flex',alignItems:'center',gap:7}}>
                      <div className="bi-review-name">{rv.userName||'User'}</div>
                      {rv.verifiedVisit && <span className="bi-review-badge">✓ Visited</span>}
                    </div>
                    <div className="bi-review-stars">{star(rv.rating)}</div>
                  </div>
                </div>
                {rv.comment && <p className="bi-review-text">{rv.comment}</p>}
              </div>
            ))}
          </div>
        )}

        {/* LOCATION */}
        {tab==='location' && (
          <div className="fade-in fade-d2">
            {lat && lng ? (
              <div className="bi-map-wrap">
                <iframe
                  title="map"
                  src={`https://www.openstreetmap.org/export/embed.html?bbox=${lng-.01},${lat-.01},${lng+.01},${lat+.01}&layer=mapnik&marker=${lat},${lng}`}
                />
              </div>
            ) : (
              <div className="bi-empty"><div className="bi-empty-ico">📍</div><div>Location not set</div></div>
            )}
            {biz.address && <div className="bi-card" style={{marginTop:12,fontSize:14,color:'#94a3b8'}}>📍 {biz.address}</div>}
          </div>
        )}

        <div style={{height:80}}/>
      </div>

      {/* Sticky action bar */}
      <div className="bi-bar">
        <button className="bi-bar-btn bi-bar-ghost"
          onClick={()=>{navigator.share?.({title:biz.name,url:window.location.href})||navigator.clipboard.writeText(window.location.href);}}>
          🔗 Share
        </button>
        {biz.phone && (
          <a href={`tel:${biz.phone}`} className="bi-bar-btn bi-bar-ghost" style={{textDecoration:'none',maxWidth:180}}>
            📞 Call
          </a>
        )}
        {biz.modules?.bookings && (
          <button className="bi-bar-btn bi-bar-ghost" onClick={()=>navigate(`/booking/${biz._id}`)}>
            📅 Book
          </button>
        )}
        <button className="bi-bar-btn bi-bar-primary" style={{background:`linear-gradient(135deg,rgba(${r},.9),${colour})`}}
          onClick={()=>setTab('products')}>
          🛍️ Shop
        </button>
      </div>

      {/* Product modal */}
      {modal && (
        <div className="bi-modal-bg" onClick={e=>{ if(e.target===e.currentTarget) setModal(null);}}>
          <div className="bi-modal">
            {modal.images?.[0] && <img src={modal.images[0]} alt={modal.name} style={{width:'100%',height:180,objectFit:'cover',borderRadius:12,marginBottom:14}}/>}
            <div className="bi-modal-title">{modal.name}</div>
            {modal.description && <p style={{fontSize:13,color:'#94a3b8',marginTop:6,lineHeight:1.6}}>{modal.description}</p>}
            <div style={{fontSize:18,fontWeight:700,color:colour,marginTop:10}}>{fmtPrice(variant?.price||modal.price, modal.currency)}</div>

            {(modal.variants||[]).filter(v=>v.isActive).length > 0 && (<>
              <div style={{fontSize:11,color:'#64748b',textTransform:'uppercase',letterSpacing:1,marginTop:12,marginBottom:4}}>Options</div>
              <div className="bi-variant-grid">
                {modal.variants.filter(v=>v.isActive).map(v=>(
                  <button key={v._id} className={`bi-variant-btn${variant?._id===v._id?' active':''}`}
                    onClick={()=>setVariant(v)}>{v.name}</button>
                ))}
              </div>
            </>)}

            <div className="bi-qty-row">
              <button className="bi-qty-btn" onClick={()=>setQty(q=>Math.max(1,q-1))}>−</button>
              <span style={{fontSize:16,fontWeight:700,color:'#e2e8f0',minWidth:30,textAlign:'center'}}>{qty}</span>
              <button className="bi-qty-btn" onClick={()=>setQty(q=>q+1)}>+</button>
              <span style={{fontSize:12,color:'#64748b',marginLeft:4}}>× {fmtPrice((variant?.price||modal.price)*qty, modal.currency)}</span>
            </div>

            {cartMsg && <div style={{fontSize:13,color:cartMsg.includes('✅')?'#34d399':'#f87171',marginBottom:10,textAlign:'center'}}>{cartMsg}</div>}

            <div style={{display:'flex',gap:8}}>
              <button onClick={()=>setModal(null)} style={{flex:1,padding:11,borderRadius:9,border:'1px solid rgba(255,255,255,.1)',background:'rgba(255,255,255,.05)',color:'#64748b',cursor:'pointer',font:'600 13px/1 DM Sans,sans-serif'}}>Cancel</button>
              <button onClick={addToCart} disabled={cartLoading} style={{flex:2,padding:11,borderRadius:9,border:'none',background:`linear-gradient(135deg,rgba(${r},.9),${colour})`,color:'#fff',cursor:'pointer',font:'700 13px/1 DM Sans,sans-serif',opacity:cartLoading?.6:1}}>
                {cartLoading?'Adding…':'🛒 Add to Cart'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}